import React, { useEffect, useState } from 'react';
import { getActiveStaff, getSalarySlips, generateSalary, salaryAPI, staffAPI, companyAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const AVATAR_COLORS = ['#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6','#06b6d4','#ec4899','#84cc16'];
function initials(n) { return n?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase() || '?'; }

function amountInWords(n) {
  const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  function toWords(num) {
    if (num === 0) return '';
    if (num < 20) return ones[num] + ' ';
    if (num < 100) return tens[Math.floor(num/10)] + (num%10 ? ' ' + ones[num%10] : '') + ' ';
    if (num < 1000) return ones[Math.floor(num/100)] + ' Hundred ' + toWords(num%100);
    if (num < 100000) return toWords(Math.floor(num/1000)) + 'Thousand ' + toWords(num%1000);
    if (num < 10000000) return toWords(Math.floor(num/100000)) + 'Lakh ' + toWords(num%100000);
    return toWords(Math.floor(num/10000000)) + 'Crore ' + toWords(num%10000000);
  }
  const rupees = Math.floor(n);
  const paise = Math.round((n - rupees) * 100);
  let result = toWords(rupees).trim();
  if (paise > 0) result += ' and ' + toWords(paise).trim() + ' Paise';
  return result + ' Only';
}

async function printSlip(slip, staff) {
  const b = parseFloat(staff.basicSalary || 0);
  const da = parseFloat(slip?.daAmount || b * (parseFloat(staff.daPercent || 0) / 100));
  const hra = parseFloat(slip?.hraAmount || b * (parseFloat(staff.hraPercent || 0) / 100));
  const gross = parseFloat(slip?.grossSalary || b + da + hra);
  const pf = parseFloat(slip?.pfDeduction || b * (parseFloat(staff.pfPercent || 0) / 100));
  const other = parseFloat(slip?.otherDeduction || 0);
  const absent = parseFloat(slip?.absentDeduction || 0);
  const net = parseFloat(slip?.netSalary || gross - pf);
  const totalDed = pf + other + absent;
  const fmt = (n) => n.toLocaleString('en-IN', { minimumFractionDigits: 2 });
  const mon = MONTHS[(slip?.month || 1) - 1];

  let co = { name: 'GANDHWARIYA SOLUTION PRIVATE LIMITED', address: '', city: '', state: '', phone: '', email: '', website: 'https://gandhwariyasolution.com/' };
  try { const r = await companyAPI.get(); if (r.data) co = r.data; } catch {}

  const coAddr = [co.address, co.city, co.state].filter(Boolean).join(', ');

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>Payslip – ${staff.name} – ${mon} ${slip?.year}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Arial', sans-serif;
      font-size: 12px;
      color: #1a1a1a;
      background: #fff;
    }
    @page { size: A4 portrait; margin: 15mm 15mm 15mm 15mm; }
    @media print {
      body { margin: 0; }
      .no-print { display: none; }
    }

    /* ── Print button (screen only) ── */
    .print-btn {
      display: block; width: 160px; margin: 16px auto 0;
      padding: 10px 0; background: #1a237e; color: #fff;
      border: none; border-radius: 6px; font-size: 13px;
      font-weight: 700; cursor: pointer; text-align: center;
    }

    .page {
      width: 210mm;
      min-height: 297mm;
      margin: 0 auto;
      padding: 0;
      background: #fff;
      position: relative;
    }

    /* ── Company Header ── */
    .co-header {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      background: #1a237e;
      border-radius: 0;
    }
    .co-left {
      display: flex; align-items: center; gap: 14px;
      padding: 16px 20px; flex: 1;
    }
    .co-logo-img {
      width: 56px; height: 56px; border-radius: 8px;
      object-fit: contain; flex-shrink: 0;
      border: 2px solid rgba(255,255,255,0.3);
      background: #fff;
    }
    .co-logo-initials {
      width: 56px; height: 56px; border-radius: 8px;
      background: rgba(255,255,255,0.15);
      border: 2px solid rgba(255,255,255,0.3);
      display: flex; align-items: center; justify-content: center;
      color: #fff; font-size: 18px; font-weight: 900; letter-spacing: -1px;
      flex-shrink: 0;
    }
    .co-info { flex: 1; }
    .co-name { font-size: 15px; font-weight: 900; color: #fff; letter-spacing: 0.2px; line-height: 1.2; }
    .co-dept { font-size: 10px; color: rgba(255,255,255,0.7); margin-top: 3px; }
    .co-web  { font-size: 9px; color: rgba(255,255,255,0.55); margin-top: 2px; }
    .co-right {
      background: rgba(0,0,0,0.2);
      padding: 16px 22px;
      text-align: right;
      display: flex; flex-direction: column; justify-content: center; gap: 4px;
      min-width: 160px;
    }
    .slip-title  { font-size: 16px; font-weight: 900; color: #fff; letter-spacing: 2px; text-transform: uppercase; }
    .slip-period { font-size: 11px; color: rgba(255,255,255,0.8); }
    .slip-status {
      display: inline-block; margin-top: 4px;
      padding: 3px 10px; border-radius: 12px;
      font-size: 10px; font-weight: 800; letter-spacing: 0.5px;
    }
    .slip-status.paid   { background: #22c55e; color: #fff; }
    .slip-status.unpaid { background: #f59e0b; color: #fff; }
    .slip-status.other  { background: rgba(255,255,255,0.2); color: #fff; }

    /* ── Digital Signature ── */
    .dig-sig-section {
      display: flex; align-items: center; justify-content: space-between;
      margin: 18px 24px 0; gap: 16px;
      padding: 14px 18px;
      border: 1.5px dashed #1a237e;
      border-radius: 8px;
      background: #f8f9ff;
    }
    .dig-sig-left { flex: 1; }
    .dig-sig-title { font-size: 10px; font-weight: 800; color: #1a237e; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 6px; }
    .dig-sig-line  { font-size: 10px; color: #444; line-height: 1.7; }
    .dig-sig-line span { font-weight: 600; color: #1a237e; }
    .dig-seal {
      width: 90px; height: 90px; border-radius: 50%;
      border: 3px double #1a237e;
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      text-align: center; flex-shrink: 0;
      background: #fff;
      position: relative;
      box-shadow: 0 0 0 2px #e0e7ff;
    }
    .dig-seal-inner {
      width: 76px; height: 76px; border-radius: 50%;
      border: 1.5px solid #1a237e;
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      text-align: center;
    }
    .dig-seal-co   { font-size: 7px; font-weight: 900; color: #1a237e; letter-spacing: 0.5px; text-transform: uppercase; line-height: 1.3; }
    .dig-seal-mark { font-size: 16px; margin: 2px 0; }
    .dig-seal-text { font-size: 6.5px; color: #1a237e; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; }

    /* ── Employee Info 4-col grid ── */
    .emp-section-title {
      background: #1a237e; color: #fff;
      font-size: 9.5px; font-weight: 800; letter-spacing: 1.5px;
      padding: 5px 24px; text-transform: uppercase;
      margin-top: 10px;
    }
    .emp-section {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      border: 1px solid #d0d7e3;
      margin: 0 24px 0;
      border-radius: 0 0 6px 6px;
      overflow: hidden;
    }
    .emp-cell {
      padding: 7px 10px;
      border-right: 1px solid #d0d7e3;
      border-bottom: 1px solid #d0d7e3;
    }
    .emp-cell:nth-child(4n) { border-right: none; }
    .emp-cell:nth-last-child(-n+4) { border-bottom: none; }
    .emp-label {
      font-size: 8.5px; font-weight: 700; color: #6b7280;
      text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 3px;
    }
    .emp-val {
      font-size: 11px; font-weight: 700; color: #111827;
    }

    /* ── Attendance Bar ── */
    .att-bar {
      display: flex; margin: 10px 24px 0;
      background: #f0f4ff; border-radius: 6px;
      overflow: hidden; border: 1px solid #d0d7e3;
    }
    .att-cell {
      flex: 1; text-align: center; padding: 8px 4px;
      border-right: 1px solid #d0d7e3;
    }
    .att-cell:last-child { border-right: none; }
    .att-val { font-size: 16px; font-weight: 800; color: #1a237e; }
    .att-lbl { font-size: 9px; color: #666; margin-top: 2px; text-transform: uppercase; letter-spacing: 0.3px; }

    /* ── Earnings / Deductions ── */
    .ed-section {
      display: grid; grid-template-columns: 1fr 1fr;
      gap: 0; margin: 10px 24px 0;
      border: 1px solid #d0d7e3; border-radius: 6px; overflow: hidden;
    }
    .ed-col { }
    .ed-col:first-child { border-right: 1px solid #d0d7e3; }
    .ed-head {
      padding: 8px 12px; font-size: 10px; font-weight: 800;
      text-transform: uppercase; letter-spacing: 0.5px;
    }
    .ed-head.earn { background: #e6f4ea; color: #1b6b35; border-bottom: 1px solid #c3e6cb; }
    .ed-head.ded  { background: #fce8e8; color: #a61c1c; border-bottom: 1px solid #f5c6c6; }
    .ed-row {
      display: flex; justify-content: space-between;
      padding: 6px 12px; font-size: 11px;
      border-bottom: 1px solid #f0f0f0;
    }
    .ed-row .lbl { color: #444; }
    .ed-row .amt { font-weight: 600; color: #1a1a1a; }
    .ed-row .amt.neg { color: #b91c1c; }
    .ed-spacer { height: 6px; border-bottom: 1px solid #f0f0f0; }
    .ed-total {
      display: flex; justify-content: space-between;
      padding: 8px 12px; font-size: 11px; font-weight: 800;
      border-top: 2px solid #d0d7e3; background: #f8f9fc;
    }
    .ed-total .amt.earn-total { color: #1b6b35; }
    .ed-total .amt.ded-total  { color: #b91c1c; }

    /* ── Net Pay ── */
    .net-box {
      margin: 10px 24px 0;
      background: #1a237e;
      color: #fff;
      border-radius: 6px;
      overflow: hidden;
    }
    .net-inner {
      display: flex; align-items: center; justify-content: space-between;
      padding: 14px 20px;
    }
    .net-left .net-label { font-size: 9px; letter-spacing: 1.5px; opacity: 0.6; text-transform: uppercase; }
    .net-left .net-amount { font-size: 24px; font-weight: 900; margin-top: 2px; letter-spacing: -0.5px; }
    .net-right { text-align: right; }
    .net-words { font-size: 10px; opacity: 0.75; font-style: italic; max-width: 240px; line-height: 1.4; }
    .net-strip {
      background: #1565c0; padding: 5px 20px;
      font-size: 10px; opacity: 0.85; text-align: center; letter-spacing: 0.3px;
    }

    /* ── Signatures ── */
    .sig-section {
      display: flex; justify-content: space-between;
      margin: 20px 24px 0; gap: 24px;
    }
    .sig-box { flex: 1; text-align: center; }
    .sig-line { border-top: 1.5px solid #999; margin-top: 36px; padding-top: 6px; }
    .sig-name { font-size: 10px; font-weight: 700; color: #333; }
    .sig-sub  { font-size: 9px; color: #888; margin-top: 2px; }

    /* ── Footer ── */
    .footer {
      margin: 16px 24px 0;
      padding: 10px 14px;
      background: #f8f9fc;
      border-radius: 6px;
      border: 1px solid #e2e8f0;
      font-size: 9.5px;
      color: #666;
      line-height: 1.5;
      text-align: center;
    }
    .gen-date { font-size: 9px; color: #999; text-align: right; margin: 8px 24px 0; }
  </style>
</head>
<body>
<div class="page">

  <!-- Company Header -->
  <div class="co-header">
    <div class="co-left">
      ${co.logoUrl
        ? `<img src="${co.logoUrl}" class="co-logo-img" alt="logo" />`
        : `<div class="co-logo-initials">${(co.name || 'GS').substring(0,2).toUpperCase()}</div>`
      }
      <div class="co-info">
        <div class="co-name">${co.name || 'Company'}</div>
        <div class="co-dept">Human Resource Department</div>
        <div class="co-web">${co.website || 'https://gandhwariyasolution.com/'}</div>
        ${coAddr ? `<div class="co-web" style="margin-top:2px">${coAddr}</div>` : ''}
      </div>
    </div>
    <div class="co-right">
      <div class="slip-title">Salary Slip</div>
      <div class="slip-period">${mon} ${slip?.year}</div>
      <div>
        <span class="slip-status ${slip?.status === 'PAID' ? 'paid' : slip?.status === 'PENDING' ? 'unpaid' : 'other'}">
          ${slip?.status || 'GENERATED'}
        </span>
      </div>
    </div>
  </div>

  <!-- Employee Details — 4 column grid -->
  <div class="emp-section-title">Employee Information</div>
  <div class="emp-section">
    <div class="emp-cell"><div class="emp-label">Employee Name</div><div class="emp-val">${staff.name || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Employee Code</div><div class="emp-val">${staff.employeeCode || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Designation</div><div class="emp-val">${staff.designation || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Department</div><div class="emp-val">${staff.department?.name || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Date of Joining</div><div class="emp-val">${staff.joinDate || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">PAN Number</div><div class="emp-val">${staff.panNumber || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Pay Period</div><div class="emp-val">${mon} ${slip?.year}</div></div>
    <div class="emp-cell"><div class="emp-label">Generated On</div><div class="emp-val">${new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</div></div>
    <div class="emp-cell"><div class="emp-label">Bank Account No.</div><div class="emp-val">${staff.bankAccountNumber || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">IFSC Code</div><div class="emp-val">${staff.ifscCode || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Bank Name</div><div class="emp-val">${staff.bankName || '—'}</div></div>
    <div class="emp-cell"><div class="emp-label">Bank Branch</div><div class="emp-val">${staff.bankBranch || '—'}</div></div>
  </div>

  <!-- Attendance Summary -->
  <div class="att-bar">
    <div class="att-cell"><div class="att-val">${slip?.workingDays ?? '—'}</div><div class="att-lbl">Working Days</div></div>
    <div class="att-cell"><div class="att-val" style="color:#1b6b35">${slip?.presentDays ?? '—'}</div><div class="att-lbl">Days Present</div></div>
    <div class="att-cell"><div class="att-val" style="color:#b91c1c">${slip?.absentDays ?? '—'}</div><div class="att-lbl">Days Absent</div></div>
    <div class="att-cell"><div class="att-val">${slip?.leaveDays ?? '—'}</div><div class="att-lbl">Leave Days</div></div>
  </div>

  <!-- Earnings & Deductions -->
  <div class="ed-section">
    <!-- Earnings -->
    <div class="ed-col">
      <div class="ed-head earn">Earnings</div>
      <div class="ed-row"><span class="lbl">Basic Salary</span><span class="amt">₹${fmt(b)}</span></div>
      <div class="ed-row"><span class="lbl">Dearness Allowance (${staff.daPercent || 0}%)</span><span class="amt">₹${fmt(da)}</span></div>
      <div class="ed-row"><span class="lbl">House Rent Allowance (${staff.hraPercent || 0}%)</span><span class="amt">₹${fmt(hra)}</span></div>
      <div class="ed-spacer"></div>
      <div class="ed-total"><span>Gross Earnings</span><span class="amt earn-total">₹${fmt(gross)}</span></div>
    </div>
    <!-- Deductions -->
    <div class="ed-col">
      <div class="ed-head ded">Deductions</div>
      <div class="ed-row"><span class="lbl">Provident Fund (${staff.pfPercent || 0}%)</span><span class="amt neg">₹${fmt(pf)}</span></div>
      <div class="ed-row"><span class="lbl">Other Deductions</span><span class="amt neg">₹${fmt(other)}</span></div>
      <div class="ed-row"><span class="lbl">Absent Deduction</span><span class="amt neg">₹${fmt(absent)}</span></div>
      <div class="ed-spacer"></div>
      <div class="ed-total"><span>Total Deductions</span><span class="amt ded-total">₹${fmt(totalDed)}</span></div>
    </div>
  </div>

  <!-- Net Pay -->
  <div class="net-box">
    <div class="net-inner">
      <div class="net-left">
        <div class="net-label">Net Pay (Take Home)</div>
        <div class="net-amount">₹${fmt(net)}</div>
      </div>
      <div class="net-right">
        <div class="net-words">${amountInWords(net)}</div>
      </div>
    </div>
    <div class="net-strip">Gross Earnings ₹${fmt(gross)} &nbsp;–&nbsp; Total Deductions ₹${fmt(totalDed)} &nbsp;=&nbsp; Net Pay ₹${fmt(net)}</div>
  </div>

  <!-- Digital Signature -->
  <div class="dig-sig-section">
    <div class="dig-sig-left">
      <div class="dig-sig-title">✦ Digitally Authorised Document</div>
      <div class="dig-sig-line">Issued By &nbsp;: <span>${co.name || 'Company'}</span></div>
      <div class="dig-sig-line">Issued To &nbsp;: <span>${staff.name} (${staff.employeeCode})</span></div>
      <div class="dig-sig-line">Pay Period : <span>${mon} ${slip?.year}</span></div>
      <div class="dig-sig-line">Generated &nbsp;: <span>${new Date().toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })}</span></div>
      <div class="dig-sig-line">Ref No &nbsp;&nbsp;&nbsp;&nbsp;: <span>SLIP-${slip?.year}${String(slip?.month||1).padStart(2,'0')}-${String(staff.id||0).padStart(4,'0')}</span></div>
      <div style="margin-top:8px;font-size:9px;color:#666;font-style:italic;">
        This salary slip is digitally generated and authenticated by ${co.name || 'the company'}.<br/>
        No physical signature or stamp is required. This document is legally valid.
      </div>
    </div>
    <div class="dig-seal">
      <div class="dig-seal-inner">
        <div class="dig-seal-co">${(co.name || 'Company').split(' ').slice(0,3).join('\n')}</div>
        <div class="dig-seal-mark">✦</div>
        <div class="dig-seal-text">Digitally<br/>Signed</div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    🔒 This is a digitally authenticated salary slip — no physical signature or seal required. &nbsp;|&nbsp;
    Confidential — For the addressee only. &nbsp;|&nbsp;
    Report any discrepancy to HR within 7 days of receipt at ${co.email || 'hr@company.com'}
  </div>
  <div class="gen-date">Generated on: ${new Date().toLocaleDateString('en-IN', { day:'2-digit', month:'long', year:'numeric' })}</div>

</div>

<button class="print-btn no-print" onclick="window.print()">🖨️ Print / Save PDF</button>
<script>window.onload = function(){ window.print(); }<\/script>
</body>
</html>`);
  w.document.close();
}

function SlipModal({ slip, staff, onClose, onPrint, embedded }) {
  const b = parseFloat(staff.basicSalary || 0);
  const daAmt    = slip ? parseFloat(slip.daAmount || 0) : b * (parseFloat(staff.daPercent || 0) / 100);
  const hraAmt   = slip ? parseFloat(slip.hraAmount || 0) : b * (parseFloat(staff.hraPercent || 0) / 100);
  const gross    = slip ? parseFloat(slip.grossSalary || 0) : b + daAmt + hraAmt;
  const pf       = slip ? parseFloat(slip.pfDeduction || 0) : b * (parseFloat(staff.pfPercent || 0) / 100);
  const other    = slip ? parseFloat(slip.otherDeduction || 0) : 0;
  const absent   = slip ? parseFloat(slip.absentDeduction || 0) : 0;
  const net      = slip ? parseFloat(slip.netSalary || 0) : gross - pf;
  const totalDed = pf + other + absent;

  const Row = ({ label, amount, accent }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13 }}>
      <span style={{ color: '#475569' }}>{label}</span>
      <span style={{ fontWeight: 700, color: accent || '#0f172a' }}>₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
    </div>
  );

  const inner = (
    <div style={{ background: '#fff', borderRadius: 20, width: embedded ? '100%' : '90%', maxWidth: 580, maxHeight: embedded ? 'none' : '92vh', overflowY: 'auto', boxShadow: embedded ? '0 4px 32px rgba(0,0,0,0.08)' : '0 40px 100px rgba(0,0,0,0.4)' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #0a1628 0%, #1a237e 50%, #1565c0 100%)', padding: '28px 32px', borderRadius: '20px 20px 0 0', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', right: -20, top: -20, width: 150, height: 150, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative' }}>
          <div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: 4 }}>SALARY SLIP</div>
            <div style={{ color: '#fff', fontSize: 22, fontWeight: 800 }}>{MONTHS[(slip?.month || 1) - 1]} {slip?.year}</div>
          </div>
          {!embedded && (
            <div style={{ display: 'flex', gap: 8 }}>
              {onPrint && <button onClick={onPrint} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', padding: '0 14px', height: 36, borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>🖨️ Print</button>}
              <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: 36, height: 36, borderRadius: '50%', cursor: 'pointer', fontSize: 18 }}>✕</button>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 28, marginTop: 20, position: 'relative' }}>
          {[{ label: 'EMPLOYEE', value: staff.name }, { label: 'EMP CODE', value: staff.employeeCode }, { label: 'DEPARTMENT', value: staff.department?.name || '-' }].map(item => (
            <div key={item.label}>
              <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 10, fontWeight: 600, letterSpacing: 0.5 }}>{item.label}</div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginTop: 3 }}>{item.value}</div>
            </div>
          ))}
        </div>
        {slip && (
          <div style={{ display: 'flex', gap: 14, marginTop: 20, position: 'relative' }}>
            {[
              { label: 'Working Days', value: slip.workingDays || '-', color: '#93c5fd', bg: 'rgba(59,130,246,0.2)' },
              { label: 'Present Days', value: slip.presentDays || '-', color: '#6ee7b7', bg: 'rgba(16,185,129,0.2)' },
              { label: 'Absent Days',  value: slip.absentDays || '-',  color: '#fca5a5', bg: 'rgba(239,68,68,0.2)' },
            ].map(d => (
              <div key={d.label} style={{ background: d.bg, borderRadius: 10, padding: '8px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: d.color }}>{d.value}</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>{d.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Body */}
      <div style={{ padding: '28px 32px' }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 800, color: '#10b981', letterSpacing: 1.5, marginBottom: 12, textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 3, height: 14, background: '#10b981', borderRadius: 2 }} />EARNINGS
          </div>
          <Row label="Basic Salary" amount={b} />
          <Row label={`DA (${staff.daPercent || 0}%)`} amount={daAmt} />
          <Row label={`HRA (${staff.hraPercent || 0}%)`} amount={hraAmt} />
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '11px 0', fontSize: 14, fontWeight: 800 }}>
            <span style={{ color: '#0f172a' }}>Gross Salary</span>
            <span style={{ color: '#10b981' }}>₹{gross.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
          </div>
        </div>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, fontWeight: 800, color: '#ef4444', letterSpacing: 1.5, marginBottom: 12, textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 3, height: 14, background: '#ef4444', borderRadius: 2 }} />DEDUCTIONS
          </div>
          <Row label={`PF (${staff.pfPercent || 0}%)`} amount={pf} accent="#ef4444" />
          {other > 0 && <Row label="Other Deductions" amount={other} accent="#ef4444" />}
          {absent > 0 && <Row label="Absent Deduction" amount={absent} accent="#ef4444" />}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '11px 0', fontSize: 14, fontWeight: 800 }}>
            <span style={{ color: '#0f172a' }}>Total Deductions</span>
            <span style={{ color: '#ef4444' }}>₹{totalDed.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
          </div>
        </div>
        <div style={{ background: 'linear-gradient(135deg, #0a1628, #1a237e)', borderRadius: 14, padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 8px 24px rgba(26,35,126,0.3)' }}>
          <div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase' }}>Net Pay</div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 2 }}>{MONTHS[(slip?.month || 1) - 1]} {slip?.year}</div>
          </div>
          <div style={{ color: '#fff', fontSize: 28, fontWeight: 800 }}>₹{net.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
        </div>
      </div>
    </div>
  );

  if (embedded) return inner;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(6px)' }}>
      {inner}
    </div>
  );
}

export default function Salary() {
  const { user } = useAuth();
  if (user?.role !== 'ADMIN') return <StaffSalaryView />;
  return <AdminSalaryView />;
}

function StaffSalaryView() {
  const { user } = useAuth();
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [slip, setSlip] = useState(null);
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user?.staffId) return;
    staffAPI.getById(user.staffId).then(r => setStaffData(r.data)).catch(() => {});
  }, [user?.staffId]);

  useEffect(() => {
    if (!user?.staffId) return;
    setLoading(true);
    salaryAPI.getSlip(user.staffId, month, year)
      .then(r => {
        const slips = Array.isArray(r.data) ? r.data : r.data ? [r.data] : [];
        setSlip(slips[0] || null);
        setLoading(false);
      })
      .catch(() => { setSlip(null); setLoading(false); });
  }, [user?.staffId, month, year]);

  const prevMonth = () => { if (month === 1) { setMonth(12); setYear(y => y - 1); } else setMonth(m => m - 1); };
  const nextMonth = () => {
    const isNow = month === (now.getMonth() + 1) && year === now.getFullYear();
    if (isNow) return;
    if (month === 12) { setMonth(1); setYear(y => y + 1); } else setMonth(m => m + 1);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>My Salary</div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 2 }}>Your monthly salary slip</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fff', borderRadius: 12, padding: '8px 16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          <button onClick={prevMonth} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', fontSize: 16 }}>‹</button>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', minWidth: 130, textAlign: 'center' }}>{MONTHS[month - 1]} {year}</span>
          <button onClick={nextMonth} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', fontSize: 16, opacity: (month === now.getMonth() + 1 && year === now.getFullYear()) ? 0.3 : 1 }}>›</button>
        </div>
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 80, color: '#94a3b8' }}>Loading...</div>
      ) : !slip || !staffData ? (
        <div style={{ textAlign: 'center', padding: 80, background: '#fff', borderRadius: 16, color: '#94a3b8', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📄</div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>No salary slip for {MONTHS[month - 1]} {year}</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>Contact HR if you think this is an error</div>
        </div>
      ) : (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
            <button
              onClick={() => printSlip(slip, staffData)}
              style={{ padding: '9px 20px', background: 'linear-gradient(135deg, #1a237e, #1565c0)', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 13, boxShadow: '0 4px 14px rgba(26,35,126,0.3)' }}
            >
              🖨️ Download / Print
            </button>
          </div>
          <SlipModal slip={slip} staff={staffData} onClose={() => {}} embedded />
        </div>
      )}
    </div>
  );
}

function AdminSalaryView() {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [staff, setStaff] = useState([]);
  const [slips, setSlips] = useState([]);
  const [generating, setGenerating] = useState({});
  const [loading, setLoading] = useState(false);
  const [viewSlip, setViewSlip] = useState(null);

  useEffect(() => { getActiveStaff().then(r => setStaff(r.data || [])).catch(() => {}); }, []);
  useEffect(() => { loadSlips(); }, [month, year]);

  const loadSlips = () => {
    setLoading(true);
    getSalarySlips(month, year).then(r => { setSlips(r.data || []); setLoading(false); }).catch(() => setLoading(false));
  };

  const getSlip = id => slips.find(s => s.staff?.id === id);

  const handleGenerate = async (staffId) => {
    setGenerating(p => ({ ...p, [staffId]: true }));
    try {
      await generateSalary({ staffId, month, year });
      toast.success('Salary slip generated!');
      loadSlips();
    } catch { toast.error('Generation failed'); }
    finally { setGenerating(p => ({ ...p, [staffId]: false })); }
  };

  const totalNet = slips.reduce((s, sl) => s + parseFloat(sl.netSalary || 0), 0);

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Salary & Payroll</div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 2 }}>Generate and manage monthly salary slips</div>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <select value={month} onChange={e => setMonth(Number(e.target.value))} style={{ padding: '9px 14px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 13, background: '#fff', cursor: 'pointer' }}>
            {MONTHS.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
          </select>
          <select value={year} onChange={e => setYear(Number(e.target.value))} style={{ padding: '9px 14px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 13, background: '#fff', cursor: 'pointer' }}>
            {[2023,2024,2025,2026].map(y => <option key={y}>{y}</option>)}
          </select>
        </div>
      </div>

      {/* KPI Cards */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        {[
          { label: 'Total Staff', value: staff.length, icon: '👥', color: '#3b82f6', bg: '#eff6ff' },
          { label: 'Generated', value: slips.length, icon: '📄', color: '#10b981', bg: '#f0fdf4' },
          { label: 'Total Payroll', value: `₹${totalNet.toLocaleString('en-IN')}`, icon: '💰', color: '#f59e0b', bg: '#fffbeb' },
          { label: 'Pending', value: staff.length - slips.length, icon: '⏳', color: '#ef4444', bg: '#fff1f2' },
        ].map(c => (
          <div key={c.label} style={{ flex: 1, minWidth: 140, background: '#fff', borderRadius: 14, padding: '20px 22px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', borderTop: `4px solid ${c.color}`, position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', right: -8, top: -8, width: 60, height: 60, borderRadius: '50%', background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>{c.icon}</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: '#0f172a' }}>{c.value}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 4, fontWeight: 500 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 24px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontWeight: 700, color: '#0f172a', fontSize: 15 }}>{MONTHS[month-1]} {year} — Salary Slips</div>
          <div style={{ fontSize: 12, color: '#64748b', background: '#f8fafc', padding: '4px 12px', borderRadius: 20 }}>{slips.length} / {staff.length} generated</div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 80, color: '#94a3b8' }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>⏳</div>Loading...
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '2px solid #f1f5f9' }}>
                {['Employee','Department','Basic','Gross','Deductions','Net Salary','Status','Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 20px', textAlign: 'left', fontWeight: 700, color: '#475569', fontSize: 12, letterSpacing: 0.3 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {staff.map((s, i) => {
                const slip = getSlip(s.id);
                const b = parseFloat(s.basicSalary || 0);
                const gross = slip ? parseFloat(slip.grossSalary || 0) : b + b*(parseFloat(s.daPercent||0)/100) + b*(parseFloat(s.hraPercent||0)/100);
                const ded = slip ? parseFloat(slip.pfDeduction||0)+parseFloat(slip.otherDeduction||0)+parseFloat(slip.absentDeduction||0) : b*(parseFloat(s.pfPercent||0)/100);
                const net = slip ? parseFloat(slip.netSalary||0) : gross - ded;
                const ac = AVATAR_COLORS[i % AVATAR_COLORS.length];
                return (
                  <tr key={s.id} style={{ borderBottom: '1px solid #f8fafc', transition: 'background 0.1s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={{ padding: '13px 20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 36, height: 36, borderRadius: 10, background: ac, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 12, flexShrink: 0 }}>{initials(s.name)}</div>
                        <div>
                          <div style={{ fontWeight: 700, color: '#0f172a' }}>{s.name}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8' }}>{s.employeeCode}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '13px 20px', color: '#475569', fontSize: 12 }}>{s.department?.name || '-'}</td>
                    <td style={{ padding: '13px 20px', color: '#475569' }}>₹{b.toLocaleString('en-IN')}</td>
                    <td style={{ padding: '13px 20px', fontWeight: 700, color: '#10b981' }}>₹{gross.toLocaleString('en-IN')}</td>
                    <td style={{ padding: '13px 20px', color: '#ef4444' }}>₹{ded.toLocaleString('en-IN')}</td>
                    <td style={{ padding: '13px 20px', fontWeight: 800, fontSize: 15, color: '#1a237e' }}>₹{net.toLocaleString('en-IN')}</td>
                    <td style={{ padding: '13px 20px' }}>
                      <span style={{ padding: '4px 14px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: slip ? '#d1fae5' : '#fef3c7', color: slip ? '#065f46' : '#92400e' }}>
                        {slip ? '✓ Generated' : 'Pending'}
                      </span>
                    </td>
                    <td style={{ padding: '13px 20px' }}>
                      <div style={{ display: 'flex', gap: 7 }}>
                        {slip && (
                          <button onClick={() => setViewSlip({ slip, staff: s })} style={{ padding: '6px 14px', borderRadius: 8, background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
                            👁 View
                          </button>
                        )}
                        <button onClick={() => handleGenerate(s.id)} disabled={!!generating[s.id]} style={{
                          padding: '6px 14px', borderRadius: 8, border: 'none', cursor: generating[s.id] ? 'not-allowed' : 'pointer',
                          background: slip ? '#fff1f2' : 'linear-gradient(135deg, #1a237e, #1565c0)',
                          color: slip ? '#e11d48' : 'white', fontSize: 11, fontWeight: 700,
                          opacity: generating[s.id] ? 0.6 : 1, boxShadow: slip ? 'none' : '0 2px 8px rgba(26,35,126,0.25)',
                        }}>
                          {generating[s.id] ? '...' : slip ? '↻ Regen' : '+ Generate'}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {viewSlip && <SlipModal slip={viewSlip.slip} staff={viewSlip.staff} onClose={() => setViewSlip(null)} onPrint={() => printSlip(viewSlip.slip, viewSlip.staff)} />}
    </div>
  );
}
